import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1028 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M986.543 548.966H40.068a37.864 37.864 0 1 1 0-75.728H986.5a37.864 37.864 0 1 1 0 75.728" /><path d="M475.441 984.34V37.906a37.864 37.864 0 0 1 75.729 0v946.39a37.864 37.864 0 1 1-75.729 0" /></svg>

const Plus = React.forwardRef((props, ref) => {
  return (
    <IconBase name="plus" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Plus.displayName = 'IconPlus'

export default Plus
